import axios from '@/api/config';

const resource = {
  getResourceById(data) {
    return axios.get(`${process.env.BASE_URL}/resource/getResource/` + data, {});
  },
  getResource(data) {
      return axios.get(`${process.env.BASE_URL}/resource/getResource`, {params: data});
    },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/resource/pageList`, data);
  },
  addResource(data) {
    return axios.post(`${process.env.BASE_URL}/resource/addResource`, data);
  },
  updateResource(data) {
    return axios.put(`${process.env.BASE_URL}/resource/updateResource`, data);
  },
  deleteResource(data) {
    return axios.delete(`${process.env.BASE_URL}/resource/deleteResource`, {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/resource/exportExcel`, {params: data});
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/resource/importData`, data);
  },
  getResourceTree() {
    return axios.get(`${process.env.BASE_URL}/resource/getResourceTree`, {});
  },
  getMenu() {
    return axios.get(`${process.env.BASE_URL}/resource/getMenu`, {});
  }
}

export default resource;



// WEBPACK FOOTER //
// ./src/api/resource.js